import React, { useEffect } from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import MyhouseAuthMethod from '../MyhouseAuthMethod'

import style from './MyhouseAuthResidentMethod.module.scss'

import BlindContent from '@Components/VAC/common/BlindContent'
import useBrowser from '@Hooks/myhouse/useBrowser'
import { AUTHENTICATION_MAX_COUNT } from '@Root/contants/myhouse'
import MyhouseAuthProgress from '@Components/atoms/MyhouseAuthProgress'
import useAuthentication from '@Hooks/myhouse/useAuthentication'
import { FETCH_STATUS } from '@Root/contants'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import { lcsSend } from '@Helpers/lcs'
import { NDS_PROTOCOL } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  onMaintainFeeAuthClick: (e: React.SyntheticEvent) => void
  onPackageAuthClick: (e: React.SyntheticEvent) => void
  realestateTypeCode?: string
  residentAuthCount: number
}

const MyhouseAuthResidentMethod: React.FC<Props> = ({ onMaintainFeeAuthClick, onPackageAuthClick, realestateTypeCode, residentAuthCount }: Props) => {
  const { browser } = useBrowser()
  const { isMobile, isIpad } = browser
  const { push } = useHistory()
  const { authentication, loadNpayAuthentication } = useAuthentication()
  const { houseNo, npayAuthentication, fetchStatus } = authentication

  useEffect(() => {
    lcsSend(NDS_PROTOCOL.MY_HOUSE.AUTHENTICATION.RESIDENT)
  }, [])

  useEffect(() => {
    if (fetchStatus === FETCH_STATUS.SUCCESS) {
      loadNpayAuthentication(houseNo)
    }
  }, [fetchStatus])

  useEffect(() => {
    if (npayAuthentication.fetchStatus === FETCH_STATUS.SUCCESS) {
      if (npayAuthentication.result === true) {
        push(`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/${houseNo}?popup=${MODAL_TYPE[MODAL_TYPE.NPAY_AUTHENTICATION_SUCCESS]}`)
      }
    }
  }, [npayAuthentication.fetchStatus])

  if (npayAuthentication.fetchStatus === FETCH_STATUS.PENDING || npayAuthentication.result === true) {
    return <MyhouseAuthProgress showGuide={true} />
  }

  return (
    <section id="content" className={cx('article')} role="main">
      <BlindContent />
      <div className={cx('inner')}>
        <h3 className={cx('title')}>
          입주민 인증을 위해
          <br />
          아래 방법 중 하나를 선택해 주세요.
        </h3>
        {residentAuthCount > 0 &&
          ((residentAuthCount >= AUTHENTICATION_MAX_COUNT && (
            <p className={cx('text')}>
              더 이상 인증을 할 수 없습니다.({residentAuthCount}/{AUTHENTICATION_MAX_COUNT})
            </p>
          )) || (
            <p className={cx('text')}>
              입주민 인증은 한 번 더 시도할 수 있습니다.({residentAuthCount}/{AUTHENTICATION_MAX_COUNT})
            </p>
          ))}

        {realestateTypeCode && realestateTypeCode === 'A01' && (
          <MyhouseAuthMethod
            onClick={onMaintainFeeAuthClick}
            text={'우리집의 지난 달'}
            title={'관리비 고지서 촬영하기'}
            wrapClass={'article_resident'}
            errorCount={residentAuthCount}
            mobileOnly
            isMobile={isMobile || isIpad}
          />
        )}
        <MyhouseAuthMethod
          onClick={onPackageAuthClick}
          text={'우리집으로 배송된'}
          title={'택배 또는 우편물 촬영하기'}
          wrapClass={'article_resident'}
          errorCount={residentAuthCount}
          mobileOnly
          isMobile={isMobile || isIpad}
        />
      </div>
    </section>
  )
}

export default MyhouseAuthResidentMethod
